module.exports = __webpack_public_path__ + "static/img/stitch.6ad3632.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programs_icons/stitch.svg
// module id = EPpU
// module chunks = 1